import * as React from 'react';

import AnnotationsRegion16 from './AnnotationsRegion16';

export const annotationsRegion16 = () => <AnnotationsRegion16 />;

export default {
    title: 'Icon|Fill|AnnotationsRegion16',
    component: AnnotationsRegion16,
    parameters: {
        notes: "`import AnnotationsRegion16 from 'box-ui-elements/es/icon/fill/AnnotationsRegion16';`",
    },
};
